import { render, staticRenderFns } from "./FKomoditiTypeDialog.vue?vue&type=template&id=6a04af76&scoped=true"
import script from "./FKomoditiTypeDialog.vue?vue&type=script&lang=js"
export * from "./FKomoditiTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./FKomoditiTypeDialog.vue?vue&type=style&index=0&id=6a04af76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04af76",
  null
  
)

export default component.exports